__turbopack_context__.v({
  "action": "c63dXW_action",
  "collapse": "c63dXW_collapse",
});
